import styled from "styled-components";
import { isIOS, isMacOs } from "react-device-detect";
import { media } from "../../layouts/utils";
import { Button } from "veloe-ds";

const blur = `
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(10px);
  pointer-events: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

export const CustomButtom = styled(Button)`
  .label {
    ${(isIOS || isMacOs) &&
      `
      top: 0;
    `}
  }
  ${media.phone`
    width: 134px !important;
`}
  ${media.smallPhone`
  width: 134px !important;
  `}
  ${(props) => props.blur && blur}
`;
